import type {
  NavCard,
  NavCardById,
  NavCardState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/navCard';

export const getAll = (state: NavCardState): NavCardById => state.byId;
export const get = (state: NavCardState, id: string): NavCard => state.byId[id];
